// Direct single-document lookup for the page editor.
//
// Opening a page used to download the ENTIRE page collection (every page with its full data —
// ~5 MB / several seconds) and find the one by id client-side, which made the editor stall on
// "Loading page…". This resolves the one document by its stable id in O(1) instead.
//
// Goes through the shared `axios` instance (NOT raw fetch) so the Auth0AxiosBridge interceptor
// attaches the admin Bearer token. Returns null on 404 so callers can show "not found".
//
// NOTE: this is a HAND-WRITTEN client, so it lives beside its only consumer rather than in
// `src/API/` — that directory is wiped and regenerated wholesale by `npm run swagger`
// (openapi-generator), which would delete any bespoke file placed inside it. Same convention as
// `src/Pages/SearchTags/searchTagsClient.ts`.
import axios from "axios";
import type { ContentDocument } from "../../API/Models";

const apiBase = (process.env.REACT_APP_API_URL ?? "").replace(/\/+$/, "");

export async function getContentById(id: string): Promise<ContentDocument | null> {
	try {
		const r = await axios.get<ContentDocument>(`${apiBase}/api/content/by-id`, {
			params: { id },
			withCredentials: true,
		});
		return r.data ?? null;
	} catch (e: any) {
		if (e?.response?.status === 404) return null;
		throw e;
	}
}
